module.exports = __webpack_public_path__ + "static/media/icon-cards.fbcb25dd.svg";